import { useState, useEffect } from 'react';

/**
 * useTheme hook to manage light/dark theme.
 * - Persists theme in localStorage.
 * - Toggles root .dark class for dark mode.
 */
export default function useTheme() {
  const [theme, setTheme] = useState(() => {
    // Load initial theme from localStorage or default to 'light'
    const stored = localStorage.getItem('theme');
    return stored ? stored : 'light';
  });

  useEffect(() => {
    // Apply or remove the 'dark' class on the root <html> element
    if (theme === 'dark') {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
    localStorage.setItem('theme', theme);
  }, [theme]);

  // Toggle function to switch themes
  const toggleTheme = () => {
    setTheme(prev => (prev === 'light' ? 'dark' : 'light'));
  };

  return { theme, toggleTheme };
}
